import { useEffect, useState } from "react";
import Table from "react-bootstrap/Table";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import ButtonToolbar from "react-bootstrap/ButtonToolbar";
import moment from "moment";
import { apiRequest } from "../../apiServices/allApi";

function Allhistory() {
  const location = useLocation();
  const path = location.pathname.split("/")[3];

  const [all, setAll] = useState("all");
  const [kyc, setKyc] = useState("");
  const [wallet, setWallet] = useState("");
  const [data, setData] = useState([]);

  const getHistory = async () => {
    let access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(
        `admin/activity_user_history/${path}/${all}${kyc}${wallet}`,
        "GET",
        null,
        headers,
      );
      setData(res.data?.data);
    } catch (e) {
    } finally {
    }
  };

  useEffect(() => {
    getHistory();
  }, [all, kyc, wallet]);

  // const[all,setAll]=useState("");

  return (
    <>
      <div className="mb-4">
        <ButtonToolbar aria-label="Toolbar with button groups">
          <ButtonGroup className="me-2" aria-label="First group">
            <Button
              className={
                all.length > 0 ? "btn btn-secondary" : "btn btn-primary"
              }
              onClick={() => {
                setAll("all");
                setKyc("");
                setWallet("");
              }}
            >
              All Activity
            </Button>
            <Button
              className={
                kyc.length > 0 ? "btn btn-secondary" : "btn btn-success"
              }
              onClick={() => {
                setAll("");
                setKyc("");
                setKyc("kyc");
              }}
            >
              Kyc
            </Button>
            <Button
              className={
                wallet.length > 0 ? "btn btn-secondary" : "btn btn-info"
              }
              onClick={() => {
                setAll("");
                setKyc("");
                setWallet("wallet");
              }}
            >
              Wallet
            </Button>
          </ButtonGroup>
        </ButtonToolbar>
      </div>
      {all?.length > 0 ? (
        <div style={{ overflow: "scroll" }}>
          <Table
            bordered
            hover
            variant=""
            className="bg-white text-dark"
            style={{ color: "black" }}
          >
            <thead>
              <tr>
                <th className="text-dark">#</th>
                <th className="text-dark">Action By</th>
                <th className="text-dark">IP</th>
                <th className="text-dark">Description</th>
                <th className="text-dark">Amount</th>
                <th className="text-dark">Time</th>
              </tr>
            </thead>
            <tbody style={{ color: "black" }}>
              {data &&
                data?.map((item, index) => {
                  return (
                    <tr
                      className={
                        item.Req_type == "kyc" ? `text-info` : `text-black`
                      }
                    >
                      <td className="text-dark">{index + 1}</td>
                      <td className="text-dark">{item.actionBy?.Name}</td>
                      <td className="text-dark">{item.ip}</td>
                      <td className="text-dark">{item.txn_msg}</td>
                      <td className="text-dark">
                        {item.amount == null ? item.amount : 0}
                      </td>
                      {/* <td className='text-dark'>{item.createdAt.slice(0,10)}{" "}{item.createdAt.slice(11,19)}</td> */}
                      <td className="text-dark">
                        {moment(item?.createdAt).format(
                          "MMMM Do YYYY, h:mm:ss a",
                        )}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </Table>
        </div>
      ) : kyc.length > 0 ? (
        <Table
          bordered
          hover
          variant=""
          className="bg-white text-dark"
          style={{ color: "white" }}
        >
          <thead>
            <tr>
              <th className="text-dark">#</th>
              <th className="text-dark">Action By</th>
              <th className="text-dark">IP</th>
              <th className="text-dark">Description</th>
              <th className="text-dark">Time</th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data?.map((item, index) => {
                return (
                  <tr className="">
                    <td className="text-dark">{index + 1}</td>
                    <td className="text-dark">{item.actionBy?.Name}</td>
                    <td className="text-dark">{item.ip}</td>
                    <td className="text-dark">{item.txn_msg}</td>
                    <td className="text-dark">
                      {item.amount == null ? item.amount : 0}
                    </td>
                    <td className="text-dark">
                      {item.createdAt.slice(0, 10)}{" "}
                      {item.createdAt.slice(11, 19)}
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </Table>
      ) : (
        <Table
          bordered
          hover
          variant=""
          className="bg-white text-dark"
          style={{ color: "white" }}
        >
          <thead>
            <tr>
              <th className="text-dark">#</th>
              <th className="text-dark">Action By</th>
              <th className="text-dark">IP</th>
              <th className="text-dark">Description</th>
              <th className="text-dark">Time</th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data?.map((item, index) => {
                console.warn(item);
                return (
                  <tr className="">
                    <td className="text-dark">{index + 1}</td>
                    <td className="text-dark">{item.actionBy.Name}</td>
                    <td className="text-dark">{item.ip}</td>
                    <td className="text-dark">{item.txn_msg}</td>
                    <td className="text-dark">
                      {item.amount == null ? item.amount : 0}
                    </td>
                    <td className="text-dark">
                      {item.createdAt.slice(0, 10)}{" "}
                      {item.createdAt.slice(11, 19)}
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </Table>
      )}
    </>
  );
}

export default Allhistory;
